export const isRuResponsibleGamingPage = (): boolean => {
    const {pathname} = window.location;

    return Boolean(pathname.includes('/public/ru_responsible_gaming') ||
    pathname.includes('/public/responsible_gaming'));
};
